import { Injectable } from '@angular/core';

import { Timezones } from '../../components/shared/constants/timezones';

import * as moment from 'moment-timezone';


export class TimeService {

	// all timezones mapped by timezone name
	public mappedTimezonesWithOffset = {};

	// Timezone used on server side
	// Most probably this should be UTC in near future
	private baseTimezone: string = 'Europe/London';

	// Timezone used through our web application
	// Should be set externally once the app knows logged user's timezone
	private _appTimezone: string = null;

	private allTimezones: any = Timezones;

	constructor() {
		this.mapTimezonesWithOffset();
	}

	public setAppTimezone(newTimezone: string) {
		if (!this.isValidTimezone(newTimezone)) {
			this.setFallbackTimezone();

			return;
		}

		this._appTimezone = newTimezone;
		moment.tz.setDefault(this._appTimezone);
	}

	// if the timezone is not valid, set de fallback one (Europe/London)
	public setFallbackTimezone(): void {
		this._appTimezone = 'Europe/London';
		moment.tz.setDefault(this._appTimezone);
	}

	public get appTimezone(): string {
		return this._appTimezone;
	}

	public get timezones(): any {
		return this.allTimezones;
	}

	public getNow(format: string = 'YYYY-MM-DD HH:mm'): any {
		return moment.tz(this.appTimezone).format(format);
	}

	// Convert from base timezone to app timezone
	public convertFrom(datetime: string, format: string = 'YYYY-MM-DD HH:mm:ss'): any {
		return moment.tz(datetime, this.baseTimezone).tz(this.appTimezone).format(format);
	}

	// Convert from app timezone to base timezone
	public convertTo(datetime: string, format: string = 'YYYY-MM-DD HH:mm:ss'): any {
		return moment.tz(datetime, this.appTimezone).tz(this.baseTimezone).format(format);
	}

	public getTimezoneOffset(timezone: string): string {
		if (typeof this.mappedTimezonesWithOffset[timezone] !== 'undefined') {
			return this.mappedTimezonesWithOffset[timezone].offset;
		}

		return '';
	}

	private mapTimezonesWithOffset(): void {
		moment.tz.names().forEach((item) => {
			this.mappedTimezonesWithOffset[item] = {
				timezone: item,
				offset: moment.tz(item).format('Z')
			};
		});
	}

	private isValidTimezone(timezone: string): boolean {
		if (!timezone || typeof timezone !== 'string') {
			return false;
		}

		const tzArr = timezone.split('/'); // tzArr[0] - zone, tzArr[1] - location
		if (!tzArr.length) {
			return false;
		}

		// check zone
		if (!this.allTimezones.hasOwnProperty(tzArr[0])) {
			return false;
		}

		// check location
		if (this.allTimezones[tzArr[0]].indexOf(timezone) === -1) {
			return false;
		}

		return true;
	}
static ctorParameters() { return [  ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/shared/services/time.service.ts